import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button } from 'react-bootstrap';
import { SocketContext, UserContext } from '../context/UserContext';
import Message from './Message';

const ChatBox = () => {

    const [message, setMessage] = useState('');
    const [chat, setChat] = useState([]);
    const { globalUser, updateUser,  login } = useContext(UserContext);
    const chatBoxRef = useRef(null);
    const { socket } = useContext(SocketContext)
    const [showEmoji, setShowEmoji] = useState(true);
    // const [showSubEmoji, setShowSubEmoji] = useState(false);
    const [reactions, setReactions] = useState([]);
    const lastSent = useRef(0);


    const [showNewMessageButton, setShowNewMessageButton] = useState(false);

    useEffect(() => {
      const chatBox = chatBoxRef.current;
      if (!chatBox) return;

      const handleScroll = () => {
        const isUserNearBottom = chatBox.scrollHeight - chatBox.scrollTop <= chatBox.clientHeight + 50;
        setShowNewMessageButton(!isUserNearBottom);
      };

      chatBox.addEventListener("scroll", handleScroll);
      return () => chatBox.removeEventListener("scroll", handleScroll);
    }, []);


    useEffect(() => {
      // Listen for incoming reactions
      socket.on("receive-reaction", (reaction) => {
        setReactions((prev) => {
          const maxReactions = 50;
          return [...prev, { id: Date.now(), type: reaction }].slice(-maxReactions);
        });
        // setReactions((prev) => [...prev, ]);
      });
    }, []);


     // Remove reaction after animation ends
    useEffect(() => {
      const interval = setInterval(() => {
        setReactions((prev) => prev.filter((reaction) => Date.now() - reaction.id < 3000));
      }, 100);

      return () => clearInterval(interval);
    }, []);




    useEffect(()=>{
      if(!socket) return;
      socket.on('LiveMessageReceived', handleLiveMessageRecived)
      socket.on('delete-message', handleMessageDelete)

      return () => {
        socket.off('LiveMessageReceived');
        socket.off('delete-message');
      }
    },[socket])

    useEffect(() => {
      const chatBox = chatBoxRef.current;
      if (!chatBox) return;
      const isAtBottom = chatBox.scrollHeight - chatBox.scrollTop <= chatBox.clientHeight + 110;
      // console.log("Status", isAtBottom, "Scroll Height", chatBox.scrollHeight, "ScrollTop", chatBox.scrollTop, "ClientHeight", chatBox.clientHeight)
      
      if (isAtBottom) {
        setTimeout(() => {
          chatBox.scrollTo({
            top: chatBox.scrollHeight,
            behavior: 'smooth',
          });
        }, 100); // Delay to ensure chat updates first
      } else {
        setShowNewMessageButton(true);
      }
    }, [chat]); // Runs when chat updates
      
    const handleLiveMessageRecived = (data) => {
      setChat((prevChat) => [...prevChat, data]);
    }

    const handleMessageDelete = (messageid) => {
      setChat((prevChat) => prevChat.filter(message => message.id !== messageid));
    }


    const deleteMessage = (messageid) => {
      socket.emit("delete-message", messageid);
    }

    const sendMessage = () => {
      if (message.trim() !== '') {
        const currentDate = new Date();
        let hours = currentDate.getHours();
        const minutes = currentDate.getMinutes();
        hours = hours % 12;
        hours = hours ? hours : 12; 
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
        const time = `${hours}:${formattedMinutes}`;
        const data = {
          id: Date.now() + Math.floor(Math.random() * 1000),
          FullName:globalUser?.FullName,
          Content:message,
          UserID:globalUser?.ID,
          time : time
        }
        setChat((prevChat) => [...prevChat, data]);
        setMessage(''); 
        setShowEmoji(true);
        socket.emit('sendLiveMessage',data)
      }
    };

    const sendEmoji = (emoji) => {
      // const data = {
      //   FullName:globalUser?.FullName,
      //   Content: emoji
      // }
      // setChat((prevChat) => [...prevChat, data]);
      // setMessage('');

      const now = Date.now();
      if (now - lastSent.current > 500) { // 500ms throttle
        socket.emit("send-reaction", emoji);
        lastSent.current = now;
      }      
      // socket.emit('sendLiveMessage',data)
    }

    const handleMessageChange = (e) => {
      if(e.target.value.trim().length == 0){
        setShowEmoji(true);
      }else{
        setShowEmoji(false);
        // setShowSubEmoji(false)
      }
      setMessage(e.target.value);
    } 

    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
          sendMessage();
      }
    };

    const showEmojiCnt = () => {
      // setShowSubEmoji(!showSubEmoji);
    }
    
  return (
    <>
      <div style={{flexGrow:1, position:'relative'}} className='d-flex bg-white'>
          <div ref={chatBoxRef} style={{flexGrow:1, scrollbarWidth: 'none', overflowY:'scroll', maxHeight:'50vh', paddingBottom:80, paddingTop:10, paddingInline:10}}>
            {chat.map((message, index)=>(
              <Message key={index} user={message.FullName} content={message.Content} time={message.time} userid={message.UserID} messageid={message.id}  onmessagedelete={deleteMessage}/>
            ))}
          </div>
          {/* <div className="reaction-container">
            {reactions.map((reaction, index) => (
              <div key={index} className={`reaction-icon`}>{reaction.type}</div>
            ))}
          </div> */}
          <div className='w-100 p-2 bg-white' style={{position:'absolute', bottom:0}}>
            {/* {(showSubEmoji)?
              <div style={{userSelect : 'none'}} className="border mb-1 rounded-pill d-flex justify-content-between ps-3 pe-3">
                <div onClick={()=> sendEmoji('🙏')} className="rounded-circle p-2">🙏</div>
                <div onClick={()=>sendEmoji('👏')} className="rounded-circle p-2">👏</div>
                <div onClick={()=>sendEmoji('🧡')} className="rounded-circle p-2">🧡</div>
                <div onClick={()=>sendEmoji('😍')} className="rounded-circle p-2">😍</div>
                <div onClick={()=>sendEmoji('🚩')} className="rounded-circle p-2">🚩</div>
              </div>
              :''
            } */}
              <div className='d-flex'>
                  <input onChange={handleMessageChange} onKeyDown={handleKeyDown} value={message} className='form-control shadow-none' placeholder='Enter Message'/>
                  {/* {(showEmoji) ? <button onClick={()=>sendEmoji('👏')} className='btn ms-1 border shadow-none'>👏</button> : <button onClick={sendMessage} className='btn ms-1 btn-success shadow-none'><i className="bi bi-send"></i></button>} */}
                  <button onClick={sendMessage} className='btn ms-1 btn-success shadow-none'><i className="bi bi-send"></i></button>
              </div>
          </div>
      </div>
      {showNewMessageButton && (
        <button 
          onClick={() => chatBoxRef.current.scrollTo({ top: chatBoxRef.current.scrollHeight, behavior: 'smooth' })}
          className="btn btn-secondory border rounded-pill btn-sm shadow-none shadow-sm bg-white"
          style={{ position: 'absolute', bottom: '55px', right: '35%', fontSize:12  }}
        >
          <i className="bi bi-arrow-down-circle"></i> New Messages
        </button>
      )}

    </>
  )
}

export default ChatBox